// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * VehiclesService - Voertuigen & Mobiliteit
 * Stores all vehicle data as a single encrypted blob in db.wishes
 * using moduleKey 'vehicles' - identiek mechanisme aan de notariële service.
 */
import { wizardLoad, wizardSave } from '@/services/wizard'
import { saveModuleProgress }     from '@/services/profile'
import { EMPTY_VEHICLES, type VehicleData } from '@/types/vehicle'

const MODULE_KEY = 'vehicles'

export async function loadVehicles(userId: string): Promise<VehicleData> {
  const data = await wizardLoad<VehicleData>(userId, MODULE_KEY)
  return data ?? { ...EMPTY_VEHICLES, vehicles: [] }
}

export async function saveVehicles(userId: string, data: VehicleData): Promise<void> {
  const filled = data.vehicles.length
  await wizardSave(userId, MODULE_KEY, data, filled)
  // Lijst-module: zodra ≥1 voertuig is ingevoerd geldt de module als ingevuld.
  await saveModuleProgress(userId, MODULE_KEY, filled > 0 ? 1 : 0, 1)
}
